import type { TopologyGraphPreset } from '@ipfabric/utils';
import { deleteTopologyPreset } from 'components/Graph/commands/settings/deleteTopologyPreset';
import { isPresetValid } from 'components/Graph/helpers/isPresetValid';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export interface ChangeTopologyPresetDraftCommand {
  presetId: TopologyGraphPreset['id'];
}

export const changeTopologyPresetDraft: GraphCommandFactory<
  ChangeTopologyPresetDraftCommand
> = (cmdContext, dispatch) => (command) => {
  const {
    layoutSettings: { presets },
  } = cmdContext.getState();
  const foundPreset = presets.find((preset) => preset.id === command.presetId);

  if (foundPreset) {
    cmdContext.updateState((draft) => {
      // Always set found preset to be able to delete it if user has permissions
      draft.layoutSettings.presetDraft = foundPreset;
    });

    // Delete preset if it's invalid. Should not happen in production because preset should be migrated
    if (!isPresetValid(foundPreset)) {
      cmdContext.showNotification({
        type: 'warning',
        message: cmdContext.msg.canvasGraph.invalidPreset(foundPreset.name),
      });

      if (cmdContext.permissionScope.includes('settings')) {
        dispatch(deleteTopologyPreset, { id: foundPreset.id });
      }

      // Has to fall back to system preset even if deleting to avoid invalid call on immediate apply
      // Using system preset instead of previously selected to keep consistency with deleting scenario
      cmdContext.updateState((draft) => {
        // Fixed noUncheckedIndexedAccess NIM-19408
        draft.layoutSettings.presetDraft = draft.layoutSettings.presets[0]!;
      });
    }
  }
};
